import DownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import FilterIcon from "@mui/icons-material/FilterListRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";

interface Props {
  disabled?: boolean;
  loading?: boolean;
  noFilteredDocuments?: boolean;
  onDownloadAllDocuments: () => void;
  onDownloadFilteredDocuments: () => void;
}

const DownloadDocumentsButton = ({
  disabled,
  loading,
  noFilteredDocuments,
  onDownloadAllDocuments,
  onDownloadFilteredDocuments,
}: Props) => {
  return (
    <ActionsMenuButton
      text="Documents"
      variant="outlined"
      color="secondary"
      icon={<DownloadIcon />}
      disabled={disabled}
      loading={loading}
      items={[
        {
          label: "All documents",
          icon: <DownloadIcon />,
          onClick: onDownloadAllDocuments,
        },
        {
          label: "Only filtered documents",
          icon: <FilterIcon />,
          disabled: noFilteredDocuments,
          tooltip: noFilteredDocuments ? "No documents match the current filters" : undefined,
          onClick: onDownloadFilteredDocuments,
        },
      ]}
    />
  );
};

export default DownloadDocumentsButton;
